var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlashOff = function SvgFlashOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.406 2.852A1.33 1.33 0 0 1 9.65 2h8.516c.927 0 1.57.922 1.252 1.792L17.324 9.5h4.837c1.178 0 1.777 1.416.957 2.262L9.784 25.503c-1.14 1.175-3.106.117-2.753-1.482l1.66-7.521H5.917a1.917 1.917 0 0 1-1.787-2.61zm1.358.648L5.528 14.433a.417.417 0 0 0 .389.567h3.708a.75.75 0 0 1 .732.912l-1.861 8.433c-.01.047-.002.069.004.08a.14.14 0 0 0 .059.057.14.14 0 0 0 .08.018c.012-.002.035-.007.069-.041L21.768 11H16.25a.75.75 0 0 1-.704-1.008l2.38-6.492z"
  })));
};
export default SvgFlashOff;